import {Nullish} from 'utility-types';

import {
  useLazyGetCustomTenantCatalogueQuery,
  useLazyGetMakeModelWithMakeQuery,
} from '@dms/api/sales';
import {GetApiMakeModelWithMakeApiResponse, VehicleTypeEnumObject} from '@dms/api/shared';
import i18n, {FALLBACK_LANGUAGE} from '@dms/i18n';

import {vehicleModelParser, Option} from 'features/vehicle-catalogue';

interface DecodeModelProps {
  vehicleType: VehicleTypeEnumObject | Nullish;
  make: string | Nullish;
  unknownModels?: Option[];
}

export function useLazyVehicleModel() {
  const [getVehicleModel, vehicleModelApi] = useLazyGetMakeModelWithMakeQuery();
  const [getCustomTenantCatalogue, customTenantCatalogueApi] =
    useLazyGetCustomTenantCatalogueQuery();

  const isLoading = vehicleModelApi.isLoading || customTenantCatalogueApi.isLoading;
  const isError = vehicleModelApi.isError || customTenantCatalogueApi.isError;

  const decodeModel = async (props: DecodeModelProps) => {
    const unknownModels = props.unknownModels || [];

    let vehicleModelData: GetApiMakeModelWithMakeApiResponse | Nullish = null;

    if (props.vehicleType && props.make) {
      const vehicleModelQuery = await getVehicleModel(
        {
          vehicleType: props.vehicleType,
          make: props.make,
          lang: [i18n.resolvedLanguage ?? FALLBACK_LANGUAGE],
        },
        true
      ).catch(() => null);

      vehicleModelData = vehicleModelQuery?.data;
    }

    const customTenantMakeModelsQuery = await getCustomTenantCatalogue(undefined, true).catch(
      () => null
    );

    return vehicleModelParser({
      vehicleType: props.vehicleType,
      customMakeLabel: props.make,
      fallbackMakeLabel: i18n.t('entity.vehicle.labels.otherLabel'),
      unknownModels,
      vehicleModelData,
      customTenantMakeModelData: customTenantMakeModelsQuery?.data,
    });
  };

  return {decodeModel, isLoading, isError};
}
